import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './AddToCartButton.module.scss'

interface IAddToCartButtonProps {
  amount: number
  findability: boolean
  limit: number
  disabled?: boolean
  spread?: boolean
  onAdd: (qnt: number) => void
}

const AddToCartButton = ({
  amount,
  findability,
  limit,
  disabled = false,
  spread = false,
  onAdd
}: IAddToCartButtonProps) => {
  const { t } = useSurveyLocale()
  const atCap = !findability && limit > 0 && amount >= limit

  if (findability || amount <= 0) {
    return (
      <button
        type="button"
        data-testid="SW-EC-AddToCartButton"
        className={style.addButton}
        disabled={disabled}
        onClick={event => {
          event.stopPropagation()
          onAdd(1)
        }}
      >
        {t('questions', 'ec', 'kroger', 'addToCart')}
      </button>
    )
  }

  return (
    <div
      data-testid="SW-EC-AddToCartButton"
      className={`${style.stepper} ${spread ? style.stepperSpread : ''}`}
      onClick={event => event.stopPropagation()}
    >
      <button
        type="button"
        className={style.minus}
        onClick={() => onAdd(-1)}
        disabled={disabled}
        aria-label={t('questions', 'ec', 'kroger', amount === 1 ? 'remove' : 'decreaseQuantity')}
      >
        <i className="pi pi-minus" />
      </button>
      <span className={style.qtyBlock}>
        <span className={style.qty}>{amount}</span>
        <span className={style.inCart}>{t('questions', 'ec', 'kroger', 'inCart')}</span>
      </span>
      <button
        type="button"
        className={style.plus}
        onClick={() => onAdd(1)}
        disabled={atCap || disabled}
        aria-label={t('questions', 'ec', 'kroger', 'increaseQuantity')}
      >
        <i className="pi pi-plus" />
      </button>
    </div>
  )
}

export default AddToCartButton
